// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"f279d41b","157":"f279d41b","302":"f279d41b","649":"f279d41b","731":"f279d41b","926":"f279d41b"}[chunkId] + ".chunk.css";
};